import React from "react";
import { LinearProgress } from "@material-ui/core";
import useStyles from "./styles";

const ProgressBar = props => {
  const classes = useStyles();
  const { value, status } = props;

  return (
    <div className={classes.root}>
      <LinearProgress
        variant="determinate"
        value={value ? value * 100 : 0}
        className={
          status === "Overdue"
            ? classes.overdue
            : status === "Completed"
            ? classes.completed
            : classes.inProgress
        }
      />
    </div>
  );
};

export default ProgressBar;
